export default function LightIcon({ color = "white" }) {
	return (
		<svg width="2.3rem" height="2.2rem" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M12.0292 3.6665C11.9671 3.6665 11.9085 3.69536 11.8707 3.74459L5.56101 11.95C5.45987 12.0815 5.55363 12.2719 5.71955 12.2719H9.52725C9.6908 12.2719 9.78521 12.4575 9.68887 12.5897L4.95074 19.0899C4.81549 19.2755 5.04849 19.5055 5.23227 19.3678L17.4892 10.1866C17.6431 10.0713 17.5616 9.8265 17.3693 9.8265H13.8161C13.6437 9.8265 13.552 9.62286 13.6664 9.49383L18.5377 3.99918C18.6521 3.87014 18.5605 3.6665 18.3881 3.6665H12.0292Z" fill={color} />
		</svg>
	)
}
